import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';

import 'spa/Pages/Landing/Verticals/Components/centered-copy-container.less';

import {cn} from 'spa/css';

@observer
class CenteredCopyContainer extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    noMargin: PropTypes.bool,
  }

  static defaultProps = {
    noMargin: false,
  }

  render() {
    const {children, noMargin} = this.props;

    return (
      <div className="container">
        <div className={cn(
          'centered-copy-container',
          noMargin && 'centered-copy-container--no-margin',
        )}>
          {children}
        </div>
      </div>
    );
  }
}

export default CenteredCopyContainer;



// WEBPACK FOOTER //
// ./spa/Pages/Landing/Verticals/Components/CenteredCopyContainer.jsx